import styled from 'styled-components';

export const TwoRowsGameTitleContainerBox = styled.div`
    height: 3.5rem;

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        height: 2.7rem;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;
